import { render, staticRenderFns } from "./ArticleListXl.vue?vue&type=template&id=763ca254&"
import script from "./ArticleListXl.vue?vue&type=script&lang=ts&"
export * from "./ArticleListXl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports